import * as PIXI from 'pixi.js'
import Vec2 from './vec2.js'

class Z {
  constructor (game, args) {
    this.game = game
    this.texture = PIXI.Texture.from('z')
    this.view = new PIXI.Sprite(this.texture)
    const max = 0.9
    const min = 0.3
    this.view.alpha = (Math.random() * (min - max) + max).toFixed(2)
    this.view.anchor.set(0.5, 0.5)
    this.view.scale.set(0.2 + (0.25 * (args.r || 1)))
    this.isCompleted = false

    this.controls = args.controls || {
      ay: 2, // -2 ~ 2
      fade: 0.96 // 0 ~ 1
    }

    let def = {
      p: new Vec2(0, 0),
      v: new Vec2(1, 0),
      a: new Vec2(0, 0),
      r: 1,
    }
    Object.assign(def, args)
    Object.assign(this, def)
  }

  update (deltaTime = 1) {
    this.p = this.p.add(this.v)
    this.v = this.v.add(this.a)
    this.v.move(0, this.controls.ay)
    this.v = this.v.mul((0.99 - this.r / 200) * deltaTime)
    this.r *= this.controls.fade
    this.view.rotation += Math.random() * deltaTime / 4

    if (this.p.y + this.r > this.game.app.renderer.realHeight){
      this.isCompleted = true
    }

    if (this.p.y - this.r < 0){
      this.isCompleted = true
    }

    if (this.p.x + this.r > this.game.app.renderer.realWidth){
      this.isCompleted = true
    }

    if (this.p.x - this.r < 0){
      this.isCompleted = true
    }
  }

  setPosition (x, y) {
    this.view.x = x
    this.view.y = y
  }

  dropDown (originX, originY) {
    this.setPosition(this.p.x, this.p.y)
  }

  draw () {
    this.dropDown()
    this.game.app.stage.addChild(this.view)
  }

  destroy () {
    this.game.app.stage.removeChild(this.view)
    this.view = null
  }
}

export default Z
